<template>
  <!-- <div class="aplayer-pic" :style="currentPicStyleObj" @mousedown="onDragBegin"> -->
  <div class="aplayer-pic" :style="currentPicStyleObj">
    <!-- <div class="aplayer-button" @click="onClick" :class="playing ? 'aplayer-pause' : 'aplayer-play'">
    </div> -->
  </div>
</template>
<script>
import IconButton from "./aplayer-iconbutton.vue";

export default {
  components: {
    IconButton
  },
  props: {
    pic: String,
    theme: String,
    playing: {
      type: Boolean,
      default: false
    },
    enableDrag: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      hasMovedSinceMouseDown: false,
      dragStartX: 0,
      dragStartY: 0
    };
  },
  computed: {
    currentPicStyleObj() {
      if (!this.pic) return {};
      return {
        backgroundImage: `url(${this.pic})`,
        backgroundColor: this.theme
      };
    }
  },
  methods: {
    onDragBegin(e) {
      if (this.enableDrag) {
        this.hasMovedSinceMouseDown = false;
        this.$emit("dragbegin");
        this.dragStartX = e.clientX;
        this.dragStartY = e.clientY;
        document.addEventListener("mousemove", this.onDocumentMouseMove);
        document.addEventListener("mouseup", this.onDocumentMouseUp);
      }
    },
    onDocumentMouseMove(e) {
      this.hasMovedSinceMouseDown = true;
      this.$emit("dragging", {
        offsetLeft: e.clientX - this.dragStartX,
        offsetTop: e.clientY - this.dragStartY
      });
    },
    onDocumentMouseUp(e) {
      document.removeEventListener("mouseup", this.onDocumentMouseUp);
      document.removeEventListener("mousemove", this.onDocumentMouseMove);

      this.$emit("dragend");
    },
    onClick() {
      if (!this.hasMovedSinceMouseDown) {
        this.$emit("toggleplay");
      }
    }
  }
};
</script>

<style lang="scss">
@import "../scss/variables";

.aplayer-float {
  .aplayer-pic:active {
    cursor: move;
  }
}

.aplayer-pic {
  flex-shrink: 0;
  position: relative;
  height: $aplayer-height;
  width: $aplayer-height;
  background-image: url(../default.jpg);
  background-size: cover;
  transition: all 0.3s ease;
  cursor: pointer;
  &:hover {
    .aplayer-button {
      opacity: 1;
    }
  }
  .aplayer-button {
    position: absolute;
    border-radius: 50%;
    // opacity: 0.8;
    left: 50%;
    top: 50%;
    // text-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
    // box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
    // background: rgba(0, 0, 0, 0.2);
    transition: all 0.1s ease;
    .aplayer-fill {
      fill: #fff;
    }
  }

  .aplayer-play {
    width: 36px;
    height: 36px;
    // border: 2px solid #fff;
    margin-left: -13px;
    margin-top: -13px;
    background: url("../assets/play-big.png") no-repeat;
    background-position: center center;
    cursor: pointer;
    z-index: 9;
  }

  .aplayer-pause {
    width: 36px;
    height: 36px;
    // border: 2px solid #fff;
    margin-left: -13px;
    margin-top: -13px;
    background: url("../assets/pause-big.png") no-repeat;
    background-position: center center;
    cursor: pointer;
    z-index: 9;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/aplayer/components/aplayer-thumbnail.vue